module.exports = __webpack_public_path__ + "static/media/bato.cefa5655.ogg";